import { useFormContext } from "react-hook-form";

import { FileRow } from "@components";

import {
  ATTACHED_FILES,
  OtherAttachedFilesFormDataType,
} from "@validations/HRM/employee/attachedFiles";

export const UploadDocumentForm = ({
  isProfileDisabled,
}: {
  isProfileDisabled: boolean;
}) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<OtherAttachedFilesFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <FileRow
        name={ATTACHED_FILES.OTHER_DOC.UPLOAD_DOCUMENT}
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
        disabled={isProfileDisabled}
      />
    </div>
  );
};
